export const SORT_METHODS = {
    POINTS: 'points',
    NUM_ACTIONS_LOGGED: 'numberOfActionsLogged',
};
